import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "../scss/layout/PlaneDetails.scss";
import Table from "./Table";

import ImageSlider from "./ImageSlider";

const PlaneDetails = ({ airplanes: { TableOfContents, Content, TechnicalData }, ...props }) => {
	const [planeData, setPlaneData] = useState({ Content: null, TechnicalData: null });
	const [manufacture, setManufacture] = useState(null);
	const path = useLocation().pathname.split("/")[2];
	const ref = useRef();

	useEffect(() => {
		if (props.navActive) {
			ref.current.style.display = "none";
			return;
		}

		ref.current.style.display = "block";
	}, [props.navActive]);

	useEffect(() => {
		let i = 0;

		for (const val in TableOfContents) {
			if (i === 0) {
				i++;
				continue;
			}

			const reduced = TableOfContents[val].reduce((acc, v) => {
				if (v.toLowerCase().replace(/\s/g, "") === path) return val;
				return acc;
			}, "");

			if (reduced) {
				setManufacture(reduced);
				break;
			}

			i++;
		}
	}, [TableOfContents, path]);

	useEffect(() => {
		if (manufacture == null) return;
		let toSet = TechnicalData[manufacture];

		if (toSet == null) {
			toSet = null;
		} else {
			toSet = TechnicalData[manufacture][path];
		}

		setPlaneData({
			Content: Content[manufacture][path],
			TechnicalData: toSet
		});
	}, [manufacture, Content, TechnicalData, path]);

	if (planeData.Content == null) return <main className="plane_details_container" ref={ref}></main>;
	return (
		<main className="plane_details_container" ref={ref}>
			<ImageSlider images={planeData.Content.Pictures} />
			<div className="content">{planeData.Content.Content}</div>
			<Table technicalData={planeData.TechnicalData} types={TechnicalData.types} />
		</main>
	);
};

export default PlaneDetails;
